var e={exports:{}};export{e as __module};
//# sourceMappingURL=dayjs.min.js.map
